var exports = {
  "kL": "xe7b6e3d6--2baca8--container",
  "DD": "xe7b6e3d6--2baca8--title",
  "Uq": "xe7b6e3d6--2baca8--value",
};

module.exports = exports;
